<nz-layout class="h-100">
  <!-- ENCABEZADO -->
  <nz-page-header
    [nzTitle]="nzBreadcrumb"
    [class.hide]="(screenService.isMobile$ | async) && !showGlobalSearch"
  >
    <ng-template #nzBreadcrumb>
      <div class="flex-center-between">
        <nz-breadcrumb class="flex-center">
          <!--          <button style="margin-right: 6px" nz-button nzType="text" nzShape="circle" nzSize="default">-->
          <!--            <app-st-icon class="text-dark" [bold]="true" name="arrow_back"></app-st-icon>-->
          <!--          </button>-->

          @if (!(screenService.isMobile$ | async)) {
          <!--   Desktop   -->
          <ng-container>
            <nz-breadcrumb-item>
              <!--                <span class="text-label-14 text-semibold cursor-pointer">Maestros</span>-->
              <!--                 /-->
              <span>{{ maestroName }}</span>
            </nz-breadcrumb-item>
          </ng-container>
          } @else {
          <!--   Mobile   -->
          <!--            <ng-container *ngIf="(breadcrumb$ | async) as breadcrumb">-->
          <!--              &lt;!&ndash;  Si el length del breadcrumb es 3 es que se esta en el detalle de Servicios  &ndash;&gt;-->
          <!--              <app-st-icon *ngIf="breadcrumb.length === 3" style="margin-right: 5px"-->
          <!--                           [avatar]="true" [smallAvatar]="true"-->
          <!--                           [name]="gs.getServiceType(selectedService?.typeId || 0)?.icon || 'close'">-->
          <!--              </app-st-icon>-->

          <!--              <nz-breadcrumb-item>-->
          <!--                <span class="text-header-16">{{ breadcrumb[breadcrumb.length - 1].label }}</span>-->
          <!--              </nz-breadcrumb-item>-->
          <!--            </ng-container>-->
          }
        </nz-breadcrumb>
      </div>
    </ng-template>

    <nz-page-header-extra>
      <app-global-searchbar
        [ngClass]="{
          hide: (screenService.isMobile$ | async) && !showGlobalSearch
        }"
      ></app-global-searchbar>
    </nz-page-header-extra>
  </nz-page-header>

  <!-- CONTENEDOR PRINCIPAL -->
  <div
    class="maestro-wrapper"
    [class.gap-0]="(screenService.isMobile$ | async) && showGlobalSearch"
  >
    <!-- Mostrar busqueda y filtros avanzados (Mobile) -->
    <div class="mobile-search-filter">
      <button
        (click)="openFormDrawer()"
        nzShape="circle"
        nzSize="default"
        nz-button
        nzType="text"
      >
        <app-st-icon [bold]="true" name="add"></app-st-icon>
      </button>
      <button
        (click)="toggleSearch($event)"
        nzShape="circle"
        nzSize="default"
        nz-button
        nzType="text"
      >
        <app-st-icon [bold]="true" name="search"></app-st-icon>
      </button>
      <button
        (click)="toggleGlobalSearch($event)"
        nzShape="circle"
        nzSize="default"
        nz-button
        nzType="text"
      >
        <app-st-icon [bold]="true" name="travel_explore"></app-st-icon>
      </button>
      <button
        *ngIf="isKanbanAvailable()"
        (click)="setViewMode(viewMode === 'kanban' ? 'table' : 'kanban')"
        nzShape="circle"
        nzSize="default"
        nz-button
        nzType="text"
      >
        <app-st-icon
          [bold]="true"
          [name]="viewMode === 'kanban' ? 'format_list_bulleted' : 'view_kanban'"
        ></app-st-icon>
      </button>
    </div>

    <h1 *ngIf="!(screenService.isMobile$ | async)">{{ maestroName }}</h1>
    <div class="flex-center-between">
      <div class="flex-center gap-150">
      <app-pocket-searchbar
        [class.hide]="(screenService.isMobile$ | async) && !showSearch"
        [class.w-100]="screenService.isMobile$ | async"
        [(searchValue)]="searchValue"
        (searchEvent)="onSearchChanged()"
      ></app-pocket-searchbar>

      <!-- Componente de filtro en línea -->
      <app-maestro-filter
        *ngIf="enableFilters"
        [filterableColumns]="filterableColumnsList"
        (filterChange)="onFilterChange($event)"
        (filterClear)="onFilterClear()">
      </app-maestro-filter>

      <!-- Contenido personalizado (ej: badges adicionales) -->
      <ng-content select="[customActions]"></ng-content>

      <div
        *ngIf="customDrawer?.filterDrawerComponent && !enableFilters"
        (click)="openFilterDrawerRef()"
        class="st-badget"
        [ngClass]="activeFilters > 0 ? 'black' : 'subtle-grey'"
      >
        <app-st-icon class="prefix" [name]="'filter_alt'"></app-st-icon>
        <label>Filtros</label>
        <app-st-icon class="sufix" *ngIf="activeFilters==0"
                     [name]="'arrow_drop_down'"></app-st-icon>
        <span *ngIf="activeFilters > 0" class="filter-not sufix">{{
            activeFilters
          }}</span>
      </div>
      <div
        *ngIf="customDrawer?.groupDrawerComponent"
        (click)="openGroupDrawerRef()"
        class="st-badget"
        [ngClass]="activeGrouping > 0 ? 'black' : 'subtle-grey'"
      >
        <label>Agrupar por</label>
        <app-st-icon class="sufix" *ngIf="activeGrouping==0"
                     [name]="'arrow_drop_down'"></app-st-icon>
        <span *ngIf="activeGrouping > 0" class="filter-not sufix">{{
            activeGrouping
          }}</span>
      </div>
      </div>
      <div *ngIf="!(screenService.isMobile$ | async)" class="flex gap-200">
        <div *ngIf="isKanbanAvailable()" class="view-toggle" role="group" aria-label="Cambiar vista">
          <button
            type="button"
            [class.active]="viewMode === 'table'"
            (click)="setViewMode('table')"
            title="Vista tabla"
          >
            <app-st-icon name="format_list_bulleted" [bold]="true"></app-st-icon>
          </button>
          <button
            type="button"
            [class.active]="viewMode === 'kanban'"
            (click)="setViewMode('kanban')"
            title="Vista Kanban"
          >
            <app-st-icon name="view_kanban" [bold]="true"></app-st-icon>
          </button>
        </div>

        <button
          *ngIf="secondaryBtnText"
          (click)="emitSecondaryBtnClick()"
          class="flex-center-between"
          nz-button
          nzType="default"
          nzShape="round"
          nzSize="default"
        >
          <app-st-icon
            *ngIf="ms.secondaryLoading$ | async"
            class="prefix"
            name="progress_activity"
          ></app-st-icon>
          {{ secondaryBtnText }}
        </button>

        <button
          *ngIf="selectedIds.length > 0 && permissions.delete"
          (click)="openDeleteMultipleConfirmation()"
          nz-button
          nzType="text"
          nzShape="circle"
          nzSize="default"
          title="Eliminar seleccionados"
          class="delete-multiple-btn"
        >
          <app-st-icon name="delete" [bold]="true"></app-st-icon>
        </button>

        <button
          *ngIf="permissions.create"
          (click)="openFormDrawer()"
          class="flex-center-between"
          nz-button
          nzType="primary"
          nzShape="round"
          nzSize="default"
        >
          <app-st-icon class="prefix" name="add"></app-st-icon>
          {{ createButtonText }}
        </button>
      </div>
    </div>

    @if (!tableLoading) {
    @if (viewMode === 'kanban' && isKanbanAvailable()) {
    <div class="kanban-view-shell">
      <app-layout-kanban
        [maestroName]="maestroName"
        [data]="filteredData"
        [groupingActive]="activeGrouping > 0"
        [groupingCriteria]="kanbanGroupingCriteria"
        [showAddCard]="permissions.create && maestroName !== 'Presupuestos'"
        (stageDrop)="onKanbanStageDrop($event)"
        (stageAdd)="onKanbanStageAdd($event)"
        (cardClick)="openDetailsDrawerFromButton($event)"
      ></app-layout-kanban>

    </div>
    } @else {
    <nz-table
      #table
      [nzData]="renderData"
      [nzScroll]="{ x: (screenService.isMobile$ | async) ? '350px' : 'auto', y: tableScrollY }"
      class="st-bordered layout-expandable-table"
      [nzFrontPagination]="false"
      [nzShowPagination]="!!filterUtilsService?.paginationData$"
      [nzPageIndex]="paginationData?.currentPage || 1"
      [nzPageSize]="paginationData?.pageSize || calculatedPageSize"
      [nzShowSizeChanger]="showPageSizeSelector"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzTotal]="paginationData?.totalItems || 0"
      (nzPageIndexChange)="pageIndexChange($event)"
      (nzPageSizeChange)="pageSizeChange($event)"
    >
      <tr>
        @for (column of columnsDataToShow; track column) { @if
        (column.checkboxOnTable) {
        <th
          [nzAlign]="column.align || 'center'"
          [style.width]="column.width || '50px'"
        >
          <label
            nz-checkbox
            [ngModel]="allSelected"
            [nzIndeterminate]="indeterminate"
            (ngModelChange)="onSelectAll($event)"
          >
          </label>
        </th>
        } @else {
        <th
          *ngIf="!column.checkbox"
          [nzAlign]="column.align || null"
          class="layout-table-header-cell"
          [class.sorteable-column]="column.sortable"
          [class.layout-table-header-cell-resizable]="isResizableColumn(column)"
          [style.width]="
            (screenService.isMobile$ | async) && column.widthMobile
              ? column.widthMobile
              : column.width
              ? column.width
              : 'auto'
          "
        >
          {{ column.name }}

          <app-st-th-sort
            *ngIf="column.sortable"
            [sortDirection]="getColumnSortDirection(column)"
            (sortEvent)="column.sortFn && column.sortFn()"
          ></app-st-th-sort>

          <button
            *ngIf="isResizableColumn(column)"
            type="button"
            class="column-resize-handle"
            aria-label="Ajustar ancho de columna"
            (mousedown)="startColumnResize($event, column)"
            (click)="$event.preventDefault(); $event.stopPropagation()"
          >
            <app-st-icon name="drag_indicator" [bold]="true"></app-st-icon>
          </button>
        </th>
        } }
        <th
          [style.width]="
            (screenService.isMobile$ | async) && !showDetails ? '45px' : '76px'
          "
          [nzRight]="'0px'"
        ></th>
      </tr>
      <tbody>
        @for (item of table.data; track item.id) {
        <tr
          [class.st-group-row]="item.__flatGroup || item.groupName"
          [class.st-group-row-level-0]="item.__groupLevel === 0"
          [class.st-group-row-level-1]="item.__groupLevel === 1"
          [class.st-group-row-level-2]="item.__groupLevel >= 2"
        >
          @for (column of columnsDataToShow; track column; let colIndex = $index) {
          @let isFirstVisibleColumn = colIndex === 0 || (colIndex > 0 && columnsDataToShow[colIndex - 1].checkboxOnTable);

          @if (column.optionList && column.optionList.length > 0) { @if
          (column.pathData!.type === 'icon-select') {
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else if (!!item[column.pathData!.name]) {
            <app-st-icon
              [bold]="true"
              [name]="item[column.pathData!.name]"
            ></app-st-icon>
            } @else {
            <span class="color-grey-9">-</span>
            }
          </td>
          } @else {
          <td
            [style.min-width]="column.width || '50px'"
            [class.color-grey-9]="
              !item.groupName && findOptionNameById(
                item[column.pathData!.name!],
                column.optionList!
              ) === '-'
            "
          >
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            {{
              findOptionNameById(
                item[column.pathData!.name!],
                column.optionList!
              ) || "-"
            }}
            }
          </td>
          } } @else { @if (column.pathData!.type! == 'date') {
          <td
            [style.min-width]="column.width || '50px'"
            [class.color-grey-9]="!item.groupName && !deepGet(item, column.pathData!.name!)"
          >
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            {{
              deepGet(item, column.pathData!.name!)
                ? (deepGet(item, column.pathData!.name!)
                  | date : column.pathData?.dateFormat || "dd/MM/yyyy"
                  | uppercase)
                : "-"
            }}
            }
          </td>
          } @else if (column.pathData!.type! == 'date-relative') {
          <!-- Fecha relativa con punto de color -->
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else if (item.dateDeadLineData) {
            <div style="display: flex; align-items: center; gap: 8px;">
              <span
                style="width: 8px; height: 8px; border-radius: 50%; display: inline-block;"
                [style.background-color]="item.dateDeadLineData.color"
              ></span>
              <span class="text-label-12 text-semibold">{{ item.dateDeadLineData.text }}</span>
            </div>
            } @else {
            <span class="color-grey-9">-</span>
            }
          </td>
          } @else if (column.pathData!.type! == 'image') {
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            <nz-avatar
              class="not-max-width"
              (click)="openViewImageModal(item[column.pathData!.name!])"
              [nzSrc]="getSafeImageUrl(item[column.pathData!.name!])"
              style="cursor: pointer"
            ></nz-avatar>
            }
          </td>
          } @else if (column.pathData!.type! == 'avatar-select') {
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            <div style="display: flex; align-items: center; gap: 8px;">
              <nz-avatar
                *ngIf="hasAvatarOrInitials(item, column.pathData!.name!)"
                [nzSize]="23"
                [nzSrc]="getNestedProperty(item, column.pathData!.name!, 'avatar') ? getSafeImageUrl(getNestedProperty(item, column.pathData!.name!, 'avatar')) : undefined"
                [nzText]="!getNestedProperty(item, column.pathData!.name!, 'avatar') ? getInitialsFromNested(item, column.pathData!.name!) : undefined"
                [style.backgroundColor]="!getNestedProperty(item, column.pathData!.name!, 'avatar') ? '#ffffff' : undefined"
                [style.color]="!getNestedProperty(item, column.pathData!.name!, 'avatar') ? '#000000' : undefined"
                [style.border]="!getNestedProperty(item, column.pathData!.name!, 'avatar') ? '1px solid #d9d9d9' : undefined"
                [style.fontWeight]="!getNestedProperty(item, column.pathData!.name!, 'avatar') ? '600' : undefined">
              </nz-avatar>
              <span class="text-label-12 text-dark text-semibold text-nowrap">
                {{ getNestedDisplayName(item, column.pathData!.name!, column.pathData!.nestedPath) }}
              </span>
            </div>
            }
          </td>
          } @else if (column.pathData!.type! == 'multi-select') {
          <td
            style="display: flex; flex-wrap: wrap"
            [style.min-width]="column.width || '50px'"
          >
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else if (item[column.pathData!.name!] &&
            item[column.pathData!.name!].length > 0) { @for (document of
            item[column.pathData!.name!]; track document) {
            <app-doc-badget-status
              [document]="document"
            ></app-doc-badget-status>
            } } @else {
            <span class="color-grey-9">-</span>
            }
          </td>
          } @else if (column.pathData!.type! == 'boolean') {
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            {{ item[column.pathData!.name!] ? "Sí" : "No" }}
            }
          </td>
          } @else if (column.pathData!.type! == 'money-rate') { @if
          (deepGet(item, column.pathData!.name!)) {
          <td
            [style.min-width]="column.width || '50px'"
            *ngIf="
              setCurrencyData(
                deepGet(item, column.pathData!.name!),
                deepGet(item, 'isoCode'),
                !!column.pathData?.reverseRate
              ) as currencyData
            "
          >
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            <div class="flex-center gap-075" style="width: fit-content">
              <span class="text-label-12"
                >1 {{ currencyData.firstIso }} =
              </span>
              <span class="st-badget subtle-grey" style="padding: 6px 7px"
                >{{ currencyData.rate | number : "1.0-4" }}
                {{ currencyData.lastIso }}</span
              >
            </div>
            }
          </td>
          } @else {
          <td class="color-grey-9">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            -
            }
          </td>
          }           } @else if (column.pathData!.type! == 'badge'){
          <!-- Badge de etapa de oportunidad -->
          @if (column.pathData!.name === 'etapa') {
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            <ng-container
              *ngIf="item.stageData as stageData"
            >
              <span
                class="st-badget text-semibold text-nowrap"
                [style.background-color]="stageData.backgroundColor"
                [style.color]="stageData.color"
                style="display: inline-block;"
              >
                {{ stageData.label }}
              </span>
            </ng-container>
            }
          </td>
          } @else if (column.pathData!.name === 'parentEntityTypeName') {
          <!-- Badge de tipo de entidad para actividades -->
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else if (item.typeData) {
              <span
                class="st-badget text-semibold text-nowrap"
                [style.background-color]="item.typeData.backgroundColor"
                [style.color]="item.typeData.color"
                style="display: inline-block;"
              >
                {{ item.typeData.label }}
              </span>
            } @else {
              <span class="color-grey-9">{{ item.parentEntityTypeName || '-' }}</span>
            }
          </td>
          } @else if (column.pathData!.name === 'formattedState') {
          <!-- Badge especial para estado de service order -->
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            <ng-container *ngIf="item.formattedState as stateData">
              <span
                class="st-badget text-semibold text-nowrap"
                [ngClass]="stateData.class"
                style="display: inline-block;"
              >
                <app-st-icon *ngIf="stateData.icon" [name]="stateData.icon" [bold]="true" style="margin-right: 4px;"></app-st-icon>
                <label class="text-nowrap">{{ stateData.name }}</label>
              </span>
            </ng-container>
            }
          </td>
          } @else if (column.pathData!.name === 'stateData') {
          <!-- Badge de estado de actividad -->
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            <ng-container *ngIf="item.stateData as activityStateData">
              <span
                class="st-badget text-semibold text-nowrap"
                [style.background-color]="activityStateData.backgroundColor"
                [style.color]="activityStateData.color"
                style="display: inline-block;"
              >
                {{ activityStateData.label }}
              </span>
            </ng-container>
            }
          </td>
          } @else {
          <!-- Badge numérico (comportamiento original) -->
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            <nz-badge
              [nzCount]="item[column.pathData!.name!]"
              [nzStyle]="{
                backgroundColor: '#EBEBEB',
                color: '#171717',
                fontWeight: '600',
                width: '23px',
                height: '20px',
                fontSize: '10px',
                boxShadow: '0 0 0 1px #EBEBEB'
              }"
              class="badge-table"
            >
            </nz-badge>
            }
          </td>
          }
          } @else if (column.checkboxOnTable) {
          <td [nzAlign]="column.align || 'center'">
            @if (item.items && item.items.length > 0) {
            <!-- Si tiene items (es un grupo), mostrar flecha para expandir/colapsar -->
            <app-st-icon
              class="text-header-18 cursor-pointer"
              [name]="
                expandSet.has(item.id) ? 'arrow_drop_down' : 'chevron_right'
              "
              [bold]="true"
              (click)="onExpandChange(item.id, !expandSet.has(item.id))"
            ></app-st-icon>
            } @else if (item.groupName) {
            <span class="st-group-empty-toggle"></span>
            } @else {
            <!-- Si no tiene items, mostrar checkbox -->
            <label
              nz-checkbox
              [ngModel]="selectedIds.includes(item.id)"
              (ngModelChange)="onSelectItem(item.id, $event)"
            >
            </label>
            }
          </td>
          } @else if (column.visibility === 'hidden') {
          <td [style.min-width]="column.width || '50px'">
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            }
          </td>
          } @else if (column.pathData!.type! == 'currency'){
          <td
            [style.min-width]="column.width || '50px'"
            [class.color-grey-9]="!item.groupName && !item[column.pathData!.name!]"
          >
            @if (item.groupName && isFirstVisibleColumn) {
            <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
            <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
            } @else {
            ${{ item[column.pathData!.name!] || "-" }}
            }
          </td>
          } @else {
          <!-- Campo de texto normal, email con botón de enlace, o avatar para contacto/comercial -->
          @if (column.pathData!.name === 'email') {
            <td
              [style.min-width]="column.width || '50px'"
              [class.color-grey-9]="!item.groupName && (!item[column.pathData!.name!] || item[column.pathData!.name!] === '-')"
            >
              @if (item.groupName && isFirstVisibleColumn) {
              <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
              <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
              } @else {
              <div class="flex-center" style="justify-content: start">
                <span
                  class="text-nowrap"
                  [class.color-grey-9]="!item[column.pathData!.name!] || item[column.pathData!.name!] === '-'"
                >
                  {{ item[column.pathData!.name!] || "-" }}
                </span>
                <a
                  *ngIf="item[column.pathData!.name!] && item[column.pathData!.name!] !== '-'"
                  [href]="'mailto:' + item[column.pathData!.name!]"
                  target="_blank"
                >
                  <app-st-icon
                    class="cursor-pointer"
                    style="font-size: 14px; margin-left: 4px"
                    [bold]="true"
                    [name]="'open_in_new'"
                    [color]="'#666666'"
                  ></app-st-icon>
                </a>
              </div>
              }
            </td>
          } @else if (column.pathData!.name === 'name' && item.contactPartner) {
            <!-- Nombre del contacto con avatar -->
            <td [style.min-width]="column.width || '50px'">
              @if (item.groupName && isFirstVisibleColumn) {
              <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
              <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
              } @else {
              <div style="width: fit-content" class="avatar-badge">
                <nz-avatar
                  class="flex-shrink-0"
                  [nzSize]="23"
                  [nzSrc]="getSafeImageUrl(item.contactPartner.avatar)"
                ></nz-avatar>
                <span class="text-label-12 text-dark text-semibold text-nowrap">
                  {{ item.contactPartner.name }} {{ item.contactPartner.surName }}
                </span>
              </div>
              }
            </td>
          } @else if (column.pathData!.name === 'comercial' && item.comercialUser) {
            <!-- Comercial con avatar -->
            <td [style.min-width]="column.width || '50px'">
              @if (item.groupName && isFirstVisibleColumn) {
              <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
              <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
              } @else {
              <div style="width: fit-content" class="avatar-badge">
                <nz-avatar
                  class="flex-shrink-0"
                  [nzSize]="23"
                  [nzSrc]="getSafeImageUrl(item.comercialUser.avatar)"
                ></nz-avatar>
                <span class="text-label-12 text-dark text-semibold text-nowrap">
                  {{ item.comercialUser.name }} {{ item.comercialUser.surName }}
                </span>
              </div>
              }
            </td>
          } @else if (column.pathData!.type! == 'html') {
            <!-- Campo de texto HTML que se renderiza con innerHTML (opcional: truncar con maxLines) -->
            <td
              [class.color-grey-9]="!item.groupName && (!item[column.pathData!.name!] || item[column.pathData!.name!] === '-')"
              [style.min-width]="column.width || '50px'"
            >
              @if (item.groupName && isFirstVisibleColumn) {
              <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
              <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
              } @else if (item[column.pathData!.name!]) {
              <div
                [class.html-cell-truncate]="column.maxLines"
                [style.max-height]="column.maxLines ? (column.maxLines * 1.4) + 'em' : null"
                [innerHTML]="item[column.pathData!.name!]">
              </div>
              } @else {
              <span class="color-grey-9">-</span>
              }
            </td>
          } @else if (column.pathData!.type! == 'reference-link') {
            <!-- Referencia con ícono clickeable y nombre. En Actividades, todo el contenido abre el drawer de oportunidad. -->
            <td [style.min-width]="column.width || '50px'">
              @if (item.groupName && isFirstVisibleColumn) {
              <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
              <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
              } @else if (item[column.pathData!.name!]?.name) {
              <div
                style="display: flex; align-items: center; gap: 8px;"
                [class.cursor-pointer]="maestroName === 'Actividades' && item.parentEntityId"
                (click)="maestroName === 'Actividades' && item.parentEntityId ? openOpportunityDrawerFromReferenceLink(item) : null"
              >
                @if (maestroName === 'Actividades' && item.parentEntityId) {
                  <app-st-icon
                    name="open_in_new"
                    [bold]="true"
                    style="font-size: 16px; color: #1890ff;">
                  </app-st-icon>
                  <span>{{ item[column.pathData!.name!].name }}</span>
                } @else if (item[column.pathData!.name!]?.url) {
                  <a
                    [href]="item[column.pathData!.name!].url"
                    target="_blank"
                    rel="noopener noreferrer"
                    style="display: flex; align-items: center; color: #1890ff; text-decoration: none;">
                    <app-st-icon
                      name="open_in_new"
                      [bold]="true"
                      style="font-size: 16px;">
                    </app-st-icon>
                  </a>
                  <span>{{ item[column.pathData!.name!].name }}</span>
                } @else {
                  <span>{{ item[column.pathData!.name!].name }}</span>
                }
              </div>
              } @else {
              <span class="color-grey-9">-</span>
              }
            </td>
          } @else {
            <td
              [class.color-grey-9]="!item.groupName && (!item[column.pathData!.name!] || item[column.pathData!.name!] === '-')"
              [style.min-width]="column.width || '50px'"
            >
              @if (item.groupName && isFirstVisibleColumn) {
              <!-- Si es un grupo, mostrar el nombre del grupo en la primera columna visible -->
              <span class="st-group-label text-label-14 text-semibold text-dark" [style.padding-left.px]="getGroupIndent(item)">{{ item.groupName }}</span>
              } @else if (column.pathData!.nestedPath === 'phone') {
              <!-- Si es un campo de teléfono, aplicar el pipe de formateo -->
              {{ getNestedDisplayName(item, column.pathData!.name!, column.pathData!.nestedPath) | phoneFormat }}
              } @else if (column.pathData!.nestedPath) {
              <!-- Si tiene nestedPath, usar getNestedDisplayName para acceder al valor anidado -->
              {{ getNestedDisplayName(item, column.pathData!.name!, column.pathData!.nestedPath) || "-" }}
              } @else {
              {{ item[column.pathData!.name!] || "-" }}
              }
            </td>
          }
          } } }
          <td nzAlign="center" class="action-cell" [nzRight]="'0px'">
            @if (!item.groupName && !item.items) {
            <!-- Solo mostrar acciones si no es un grupo y no es una fila expandible (donde aparece la company) -->
            <button
              *ngIf="permissions.edit || permissions.delete"
              nz-button
              nzType="text"
              nzShape="circle"
              nzSize="default"
              nz-dropdown
              [nzDropdownMenu]="actionMenuNormal"
              nzTrigger="click"
            >
              <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
            </button>
            @if (showDetails) {
              <button
                *ngIf="permissions.viewDetails"
                (click)="openDetailsDrawerFromButton(item)"
                nz-button
                nzType="text"
                nzShape="circle"
                nzSize="default"
              >
                <app-st-icon
                  name="right_panel_open"
                  [bold]="true"
                ></app-st-icon>
              </button>
            }

            <nz-dropdown-menu #actionMenuNormal="nzDropdownMenu">
              <ul nz-menu>
                <!-- Para actividades: mostrar "Marcar como Hecho" en lugar de "Editar" -->
                <li
                  *ngIf="permissions.edit && maestroName === 'Actividades' && item.state !== 'Done' && item.state !== 'Cancelled'"
                  (click)="markAsDoneEvent.emit(item.id)"
                  nz-menu-item
                >
                  <button
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    nzSize="default"
                    class="flex- flex-center gap-100"
                  >
                    <app-st-icon name="check_circle" [bold]="true"></app-st-icon>
                    <span class="text-label-14 text-dark">Marcarla como Hecho</span>
                  </button>
                </li>
                <!-- Para otros componentes: mostrar "Editar" (oculto en Leads y Oportunidades) -->
                <li
                  *ngIf="permissions.edit && maestroName !== 'Actividades' && maestroName !== 'Leads' && maestroName !== 'Oportunidades'"
                  (click)="openEditFormDrawer(item)"
                  nz-menu-item
                >
                  <button
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    nzSize="default"
                    class="flex- flex-center gap-100"
                  >
                    <app-st-icon name="edit" [bold]="true"></app-st-icon>
                    <span class="text-label-14 text-dark">Editar</span>
                  </button>
                </li>
                <li
                  *ngIf="duplicateEvent.observers.length > 0"
                  (click)="duplicateEvent.emit(item.id)"
                  nz-menu-item
                >
                  <button
                    class="flex-center gap-100"
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    nzSize="default"
                  >
                    <app-st-icon
                      name="content_copy"
                      [bold]="true"
                    ></app-st-icon>
                    <span class="text-label-14 text-dark">Duplicar</span>
                  </button>
                </li>
                <li
                  *ngIf="permissions.delete"
                  (click)="openDeleteConfirmation(item.id)"
                  nz-menu-item
                >
                  <button
                    class="flex-center gap-100"
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    nzSize="default"
                  >
                    <app-st-icon
                      name="delete"
                      [bold]="true"
                    ></app-st-icon>
                    <span class="text-label-14 text-dark">Eliminar</span>
                  </button>
                </li>
              </ul>
            </nz-dropdown-menu>
            }
          </td>
        </tr>
        <!-- Filas expandidas: renderizar directamente como <tr> normales en el mismo tbody -->
        @if (expandSet.has(item.id) && item.items && !item.__flatGroup) {
          @for (itemExpand of item.items; track itemExpand.id) {
            <tr>
              @for (columnExpand of columnsDataToShow; track columnExpand; let colIndex = $index) {
                @let isFirstVisibleColumn = colIndex === 0 || (colIndex > 0 && columnsDataToShow[colIndex - 1].checkboxOnTable);
                @if (columnExpand.optionList && columnExpand.optionList.length > 0) {
                  @if (columnExpand.pathData!.type === 'icon-select') {
                    <td
                      [style.min-width]="columnExpand.width || '50px'"
                      [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                    >
                      @if (!!itemExpand[columnExpand.pathData!.name]) {
                        <app-st-icon
                          [bold]="true"
                          [name]="itemExpand[columnExpand.pathData!.name]"
                        ></app-st-icon>
                      } @else {
                        <span class="color-grey-9">-</span>
                      }
                    </td>
                  } @else {
                    <td
                      [style.min-width]="columnExpand.width || '50px'"
                      [class.color-grey-9]="
                        findOptionNameById(
                          itemExpand[columnExpand.pathData!.name!],
                          columnExpand.optionList!
                        ) === '-'
                      "
                      [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                    >
                      {{
                        findOptionNameById(
                          itemExpand[columnExpand.pathData!.name!],
                          columnExpand.optionList!
                        ) || "-"
                      }}
                    </td>
                  }
                } @else {
                  @if (columnExpand.pathData!.type! == 'date') {
                    <td
                      [style.min-width]="columnExpand.width || '50px'"
                      [class.color-grey-9]="!deepGet(itemExpand, columnExpand.pathData!.name!)"
                      [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                    >
                      {{
                        deepGet(itemExpand, columnExpand.pathData!.name!)
                          ? (deepGet(itemExpand, columnExpand.pathData!.name!)
                            | date
                              : columnExpand.pathData?.dateFormat || "dd/MM/yyyy"
                            | uppercase)
                          : "-"
                      }}
                    </td>
                  } @else if (columnExpand.pathData!.type! == 'date-relative') {
                    <!-- Fecha relativa con punto de color para filas expandidas -->
                    <td
                      [style.min-width]="columnExpand.width || '50px'"
                      [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                    >
                      @if (itemExpand.dateDeadLineData) {
                      <div style="display: flex; align-items: center; gap: 8px;">
                        <span
                          style="width: 8px; height: 8px; border-radius: 50%; display: inline-block;"
                          [style.background-color]="itemExpand.dateDeadLineData.color"
                        ></span>
                        <span class="text-label-12 text-semibold">{{ itemExpand.dateDeadLineData.text }}</span>
                      </div>
                      } @else {
                      <span class="color-grey-9">-</span>
                      }
                    </td>
                  } @else if (columnExpand.pathData!.type! == 'image') {
                    <td
                      [style.min-width]="columnExpand.width || '50px'"
                      [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                    >
                      <nz-avatar
                        class="not-max-width"
                        (click)="openViewImageModal(itemExpand[columnExpand.pathData!.name!])"
                        [nzSrc]="getSafeImageUrl(itemExpand[columnExpand.pathData!.name!])"
                        style="cursor: pointer"
                      ></nz-avatar>
                    </td>
          } @else if (columnExpand.pathData!.type! == 'avatar-select') {
          <td
            [style.min-width]="columnExpand.width || '50px'"
            [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
          >
            <div style="display: flex; align-items: center; gap: 8px;">
              <nz-avatar
                *ngIf="hasAvatarOrInitials(itemExpand, columnExpand.pathData!.name!)"
                [nzSize]="23"
                [nzSrc]="getNestedProperty(itemExpand, columnExpand.pathData!.name!, 'avatar') ? getSafeImageUrl(getNestedProperty(itemExpand, columnExpand.pathData!.name!, 'avatar')) : undefined"
                [nzText]="!getNestedProperty(itemExpand, columnExpand.pathData!.name!, 'avatar') ? getInitialsFromNested(itemExpand, columnExpand.pathData!.name!) : undefined"
                [style.backgroundColor]="!getNestedProperty(itemExpand, columnExpand.pathData!.name!, 'avatar') ? '#ffffff' : undefined"
                [style.color]="!getNestedProperty(itemExpand, columnExpand.pathData!.name!, 'avatar') ? '#000000' : undefined"
                [style.border]="!getNestedProperty(itemExpand, columnExpand.pathData!.name!, 'avatar') ? '1px solid #d9d9d9' : undefined"
                [style.fontWeight]="!getNestedProperty(itemExpand, columnExpand.pathData!.name!, 'avatar') ? '600' : undefined">
              </nz-avatar>
              <span class="text-label-12 text-dark text-semibold text-nowrap">
                {{ getNestedDisplayName(itemExpand, columnExpand.pathData!.name!, columnExpand.pathData!.nestedPath) }}
              </span>
            </div>
          </td>
                  } @else if (columnExpand.pathData!.type! == 'multi-select') {
                    <td
                      style="display: flex; flex-wrap: wrap"
                      [style.min-width]="columnExpand.width || '50px'"
                      [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                    >
                      @if (itemExpand[columnExpand.pathData!.name!] &&
                      itemExpand[columnExpand.pathData!.name!].length > 0) {
                        @for (document of itemExpand[columnExpand.pathData!.name!]; track document) {
                          <app-doc-badget-status
                            [document]="document"
                          ></app-doc-badget-status>
                        }
                      } @else {
                        <span class="color-grey-9">-</span>
                      }
                    </td>
                  } @else if (columnExpand.pathData!.type! == 'boolean') {
                    <td
                      [style.min-width]="columnExpand.width || '50px'"
                      [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                    >
                      {{ itemExpand[columnExpand.pathData!.name!] ? "Sí" : "No" }}
                    </td>
                  } @else if (columnExpand.pathData!.type! == 'money-rate') {
                    @if (deepGet(itemExpand, columnExpand.pathData!.name!)) {
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                        *ngIf="
                          setCurrencyData(
                            deepGet(itemExpand, columnExpand.pathData!.name!),
                            deepGet(itemExpand, 'isoCode'),
                            !!columnExpand.pathData?.reverseRate
                          ) as currencyData
                        "
                      >
                        <div class="flex-center gap-075" style="width: fit-content">
                          <span class="text-label-12"
                            >1 {{ currencyData.firstIso }} =
                          </span>
                          <span
                            class="st-badget subtle-grey"
                            style="padding: 6px 7px"
                            >{{ currencyData.rate | number : "1.0-4" }}
                            {{ currencyData.lastIso }}</span
                          >
                        </div>
                      </td>
                    } @else {
                      <td
                        class="color-grey-9"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >-</td>
                    }
                  } @else if (columnExpand.pathData!.type! == 'badge') {
                    <!-- Badge de etapa de oportunidad -->
                    @if (columnExpand.pathData!.name === 'etapa') {
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >
                        <ng-container
                          *ngIf="itemExpand.stageData as stageData"
                        >
                          <span
                            class="st-badget text-semibold text-nowrap"
                            [style.background-color]="stageData.backgroundColor"
                            [style.color]="stageData.color"
                            style="display: inline-block;"
                          >
                            {{ stageData.label }}
                          </span>
                        </ng-container>
                      </td>
                    } @else if (columnExpand.pathData!.name === 'parentEntityTypeName') {
                      <!-- Badge de tipo de entidad para actividades -->
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >
                        @if (itemExpand.typeData) {
                          <span
                            class="st-badget text-semibold text-nowrap"
                            [style.background-color]="itemExpand.typeData.backgroundColor"
                            [style.color]="itemExpand.typeData.color"
                            style="display: inline-block;"
                          >
                            {{ itemExpand.typeData.label }}
                          </span>
                        } @else {
                          <span class="color-grey-9">{{ itemExpand.parentEntityTypeName || '-' }}</span>
                        }
                      </td>
                    } @else if (columnExpand.pathData!.name === 'stateData') {
                      <!-- Badge de estado de actividad -->
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >
                        <ng-container *ngIf="itemExpand.stateData as activityStateData">
                          <span
                            class="st-badget text-semibold text-nowrap"
                            [style.background-color]="activityStateData.backgroundColor"
                            [style.color]="activityStateData.color"
                            style="display: inline-block;"
                          >
                            {{ activityStateData.label }}
                          </span>
                        </ng-container>
                      </td>
                    } @else {
                      <!-- Badge numérico (comportamiento original) -->
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >
                        <nz-badge
                          [nzCount]="itemExpand[columnExpand.pathData!.name!]"
                          [nzStyle]="{
                            backgroundColor: '#EBEBEB',
                            color: '#171717',
                            fontWeight: '600',
                            width: '23px',
                            height: '20px',
                            fontSize: '10px',
                            boxShadow: '0 0 0 1px #EBEBEB'
                          }"
                          class="badge-table"
                        >
                        </nz-badge>
                      </td>
                    }
                  } @else if (columnExpand.checkboxOnTable) {
                    <td
                      [nzAlign]="columnExpand.align || 'left'"
                      style="width: 10px"
                    >
                      <label
                        nz-checkbox
                        [ngModel]="selectedIds.includes(itemExpand.id)"
                        (ngModelChange)="onSelectItem(itemExpand.id, $event)"
                      >
                      </label>
                    </td>
                  } @else if (columnExpand.pathData!.type! == 'currency') {
                    <td
                      [style.min-width]="columnExpand.width || '50px'"
                      [class.color-grey-9]="!itemExpand[columnExpand.pathData!.name!]"
                      [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                    >
                      ${{ itemExpand[columnExpand.pathData!.name!] || "-" }}
                    </td>
                  } @else {
                    <!-- Campo de texto normal, email con botón de enlace, o avatar para contacto/comercial -->
                    @if (columnExpand.pathData!.name === 'email') {
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [class.color-grey-9]="!itemExpand[columnExpand.pathData!.name!] || itemExpand[columnExpand.pathData!.name!] === '-'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >
                        <div class="flex-center" style="justify-content: start">
                          <span
                            class="text-nowrap"
                            [class.color-grey-9]="!itemExpand[columnExpand.pathData!.name!] || itemExpand[columnExpand.pathData!.name!] === '-'"
                          >
                            {{ columnExpand.pathData?.displayFn ? getColumnDisplayValue(itemExpand, columnExpand) : (itemExpand[columnExpand.pathData!.name!] || "-") }}
                          </span>
                          <a
                            *ngIf="itemExpand[columnExpand.pathData!.name!] && itemExpand[columnExpand.pathData!.name!] !== '-'"
                            [href]="'mailto:' + itemExpand[columnExpand.pathData!.name!]"
                            target="_blank"
                          >
                            <app-st-icon
                              class="cursor-pointer"
                              style="font-size: 14px; margin-left: 4px"
                              [bold]="true"
                              [name]="'open_in_new'"
                              [color]="'#666666'"
                            ></app-st-icon>
                          </a>
                        </div>
                      </td>
                    } @else if (columnExpand.pathData!.name === 'name' && itemExpand.contactPartner) {
                      <!-- Nombre del contacto con avatar -->
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >
                        <div style="width: fit-content" class="avatar-badge">
                          <nz-avatar
                            class="flex-shrink-0"
                            [nzSize]="23"
                            [nzSrc]="getSafeImageUrl(itemExpand.contactPartner.avatar)"
                          ></nz-avatar>
                          <span class="text-label-12 text-dark text-semibold text-nowrap">
                            {{ getPartnerDisplayName(itemExpand.contactPartner) }}
                          </span>
                        </div>
                      </td>
                    } @else if (columnExpand.pathData!.name === 'comercial' && itemExpand.comercialUser) {
                      <!-- Comercial con avatar -->
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >
                        <div style="width: fit-content" class="avatar-badge">
                          <nz-avatar
                            class="flex-shrink-0"
                            [nzSize]="23"
                            [nzSrc]="getSafeImageUrl(itemExpand.comercialUser.avatar)"
                          ></nz-avatar>
                          <span class="text-label-12 text-dark text-semibold text-nowrap">
                            {{ itemExpand.comercialUser.name }} {{ itemExpand.comercialUser.surName }}
                          </span>
                        </div>
                      </td>
                    } @else if (columnExpand.pathData!.type! == 'html') {
                      <!-- Campo de texto HTML que se renderiza con innerHTML (opcional: truncar con maxLines) -->
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [class.color-grey-9]="!itemExpand[columnExpand.pathData!.name!] || itemExpand[columnExpand.pathData!.name!] === '-'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >
                        @if (itemExpand[columnExpand.pathData!.name!]) {
                        <div
                          [class.html-cell-truncate]="columnExpand.maxLines"
                          [style.max-height]="columnExpand.maxLines ? (columnExpand.maxLines * 1.4) + 'em' : null"
                          [innerHTML]="itemExpand[columnExpand.pathData!.name!]">
                        </div>
                        } @else {
                        <span class="color-grey-9">-</span>
                        }
                      </td>
                    } @else if (columnExpand.pathData!.type! == 'reference-link') {
                      <!-- Referencia con ícono clickeable y nombre. En Actividades, todo el contenido abre el drawer de oportunidad. -->
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >
                        @if (itemExpand[columnExpand.pathData!.name!]?.name) {
                        <div
                          style="display: flex; align-items: center; gap: 8px;"
                          [class.cursor-pointer]="maestroName === 'Actividades' && itemExpand.parentEntityId"
                          (click)="maestroName === 'Actividades' && itemExpand.parentEntityId ? openOpportunityDrawerFromReferenceLink(itemExpand) : null"
                        >
                          @if (maestroName === 'Actividades' && itemExpand.parentEntityId) {
                            <app-st-icon
                              name="open_in_new"
                              [bold]="true"
                              style="font-size: 16px; color: #1890ff;">
                            </app-st-icon>
                            <span>{{ itemExpand[columnExpand.pathData!.name!].name }}</span>
                          } @else if (itemExpand[columnExpand.pathData!.name!]?.url) {
                            <a
                              [href]="itemExpand[columnExpand.pathData!.name!].url"
                              target="_blank"
                              rel="noopener noreferrer"
                              style="display: flex; align-items: center; color: #1890ff; text-decoration: none;">
                              <app-st-icon
                                name="open_in_new"
                                [bold]="true"
                                style="font-size: 16px;">
                              </app-st-icon>
                            </a>
                            <span>{{ itemExpand[columnExpand.pathData!.name!].name }}</span>
                          } @else {
                            <span>{{ itemExpand[columnExpand.pathData!.name!].name }}</span>
                          }
                        </div>
                        } @else {
                        <span class="color-grey-9">-</span>
                        }
                      </td>
                    } @else {
                      <td
                        [style.min-width]="columnExpand.width || '50px'"
                        [class.color-grey-9]="!itemExpand[columnExpand.pathData!.name!] || itemExpand[columnExpand.pathData!.name!] === '-'"
                        [style.padding-left]="isFirstVisibleColumn ? '36px' : '16px'"
                      >
                        @if (columnExpand.pathData!.nestedPath) {
                        <!-- Si tiene nestedPath, usar getNestedDisplayName para acceder al valor anidado -->
                        {{ getNestedDisplayName(itemExpand, columnExpand.pathData!.name!, columnExpand.pathData!.nestedPath) || "-" }}
                        } @else {
                        {{ columnExpand.pathData?.displayFn ? getColumnDisplayValue(itemExpand, columnExpand) : (itemExpand[columnExpand.pathData!.name!] || "-") }}
                        }
                      </td>
                    }
                  }
                }
              }
              <td nzAlign="center" class="action-cell" [nzRight]="'0px'">
                <button
                  *ngIf="permissions.edit || permissions.delete"
                  nz-button
                  nzType="text"
                  nzShape="circle"
                  nzSize="default"
                  nz-dropdown
                  [nzDropdownMenu]="actionMenu"
                  nzTrigger="click"
                >
                  <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
                </button>
                @if (showDetails) {
                  <button
                    *ngIf="permissions.viewDetails"
                    (click)="openDetailsDrawerFromButton(itemExpand)"
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    nzSize="default"
                  >
                    <app-st-icon
                      name="right_panel_open"
                      [bold]="true"
                    ></app-st-icon>
                  </button>
                }

                <nz-dropdown-menu #actionMenu="nzDropdownMenu">
                  <ul nz-menu>
                    <!-- Para actividades: mostrar "Marcar como Hecho" en lugar de "Editar" -->
                    <li
                      *ngIf="permissions.edit && maestroName === 'Actividades' && itemExpand.state !== 'Done' && itemExpand.state !== 'Cancelled'"
                      (click)="markAsDoneEvent.emit(itemExpand.id)"
                      nz-menu-item
                    >
                      <button
                        nz-button
                        nzType="text"
                        nzShape="circle"
                        nzSize="default"
                        class="flex- flex-center gap-100"
                      >
                        <app-st-icon name="check_circle" [bold]="true"></app-st-icon>
                        <span class="text-label-14 text-dark">Marcarla como Hecho</span>
                      </button>
                    </li>
                    <!-- Para otros componentes: mostrar "Editar" (oculto en Leads y Oportunidades) -->
                    <li
                      *ngIf="permissions.edit && maestroName !== 'Actividades' && maestroName !== 'Leads' && maestroName !== 'Oportunidades'"
                      (click)="openEditFormDrawer(itemExpand)"
                      nz-menu-item
                    >
                      <button
                        nz-button
                        nzType="text"
                        nzShape="circle"
                        nzSize="default"
                        class="flex- flex-center gap-100"
                      >
                        <app-st-icon name="edit" [bold]="true"></app-st-icon>
                        <span class="text-label-14 text-dark">Editar</span>
                      </button>
                    </li>
                    <li
                      *ngIf="duplicateEvent.observers.length > 0"
                      nz-menu-item
                      (click)="duplicateEvent.emit(itemExpand.id)"
                    >
                      <button
                        class="flex-center gap-100"
                        nz-button
                        nzType="text"
                        nzShape="circle"
                        nzSize="default"
                      >
                        <app-st-icon
                          name="content_copy"
                          [bold]="true"
                        ></app-st-icon>
                        <span class="text-label-14 text-dark">Duplicar</span>
                      </button>
                    </li>
                    <li
                      *ngIf="permissions.delete"
                      nz-menu-item
                      (click)="openDeleteConfirmation(itemExpand.id)"
                    >
                      <button
                        class="flex-center gap-100"
                        nz-button
                        nzType="text"
                        nzShape="circle"
                        nzSize="default"
                      >
                        <app-st-icon
                          name="delete"
                          [bold]="true"
                        ></app-st-icon>
                        <span class="text-label-14 text-dark">Eliminar</span>
                      </button>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>
          }
        }
        }
      </tbody>
    </nz-table>
    }
    } @else {
    <nz-skeleton
      style="padding: 32px"
      [nzActive]="true"
      [nzParagraph]="{ rows: 16 }"
    ></nz-skeleton>
    }
    <ng-template #viewImageModalTmpl>
      <div
        class="confirm-modal"
        style="
          display: flex;
          flex-direction: column;
          padding: 15px;
          align-items: center;
          justify-content: center;
        "
      >
        <app-st-icon
          (click)="viewImageModalRef.close()"
          class="custom-clear"
          name="close"
          style="position: absolute; top: 15px; right: 15px; cursor: pointer"
        ></app-st-icon>
        <img style="max-width: 300px" src="{{ tmpImage }}" />
      </div>
    </ng-template>
  </div>
</nz-layout>

<app-confirmation-modal
  #confirmationModal
  (confirmed)="onDeleteConfirmed($event)"
></app-confirmation-modal>

<ng-template #notificationTmpl>
  <app-toast
    *ngIf="notRef"
    [icon]="toastConfig.icon"
    [iconColor]="toastConfig.iconColor"
    [showUndo]="toastConfig.showUndo"
    [notRef]="notRef"
    [content]="toastConfig.content"
    [msg]="toastConfig.msg"
  ></app-toast>
</ng-template>
